import axios from "axios";
import { getToken } from "@/services/jwtService";
import router from '../router';

const timeoutDuration = 30000;
const baseURL = process.env.VUE_APP_BASE_URL;
const apiURL = `${baseURL}/`;

const apiService = axios.create({
  baseURL: apiURL,
  timeout: timeoutDuration,
  headers: {
    "Content-type": "application/json",
  },
});

apiService.interceptors.request.use((config) => {
  const token = getToken();
  config.headers.Authorization = token ? `Bearer ${token}` : "";

  return config;
});

apiService.interceptors.response.use(
  (response) => response,
  async (error) => {
    /*
    * Handle invalid subdomain case
    * Note: every APIs which failed with subdomain not found will be responsed with { "errorCode": 0 }
    */
    if (error?.response?.data?.errorCode == 0) {
      router.push("/error");
    }

    return Promise.reject(error?.response || error);
  }
);

export default apiService;
